<template>
    <div>
        <!-- メッセージ -->
        <message-component id="message" v-model="isMessage" :success="message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-container>
            <v-row justify="center">
                <v-col class="thumb_wrap" v-for="(dbFile, index) in dbFileList" :key="`1st-${index}`">
                    <div class="thumb" v-show="dbFile.id">
                        <pdf-thumb-component :pdfData="dbFile.pdfData" :scale="1" max-width="196px" :suffixes="index" :key="dbFile.object_id">
                            <span class="reset_file_ico" @click="deleteDbFile(index)"><v-icon>mdi-close-circle</v-icon></span>
                        </pdf-thumb-component>
                    </div>
                    <div>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <template v-if="edit">
                                <ValidationProvider rules="required|file_name_symbol|file_name_dot|max:50" v-slot="{ errors }">
                                    <v-text-field 
                                        v-model="dbFile.contract_name" 
                                        class="file-name-text-field" 
                                        outlined
                                        clearable 
                                        v-disabled-icon-focus 
                                        dense 
                                        background-color="white"
                                        :error-messages="errors" 
                                    ></v-text-field>
                                </ValidationProvider>
                            </template>
                            <template v-else>
                                <span class="text-small" v-bind="attrs" v-on="on">{{ dbFile.contract_name | omittedText30 }}</span>
                            </template>
                          </template>
                          <span class="text-small">{{ dbFile.contract_name }}</span>
                        </v-tooltip>
                    </div>
                </v-col>
                <v-col class="thumb_wrap" v-for="(obj, index) in files" :key="`2nd-${index}`">
                    <div class="thumb" v-show="obj[0].file.name">
                        <pdf-thumb-component2 :file="obj[0].file" :scale="1" max-width="195px" :suffixes="index" :key="obj[0].sn">
                            <span class="reset_file_ico" @click="deleteFile(index)"><v-icon>mdi-close-circle</v-icon></span>
                        </pdf-thumb-component2>
                    </div>
                    <div>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <template v-if="edit">
                                    <ValidationProvider rules="required|file_name_symbol|file_name_dot|max:50" v-slot="{ errors }">
                                        <v-text-field 
                                            v-model="obj[0].file_name" 
                                            class="file-name-text-field" 
                                            outlined 
                                            clearable 
                                            v-disabled-icon-focus 
                                            dense 
                                            background-color="white"
                                            :error-messages="errors" 
                                        ></v-text-field>
                                    </ValidationProvider>
                                </template>
                                <template v-else>
                                    <span class="text-small" v-bind="attrs" v-on="on">{{ obj[0].file.name | omittedText30 }}</span>
                                </template>
                            </template>
                            <span class="text-small">{{ obj[0].file.name }}</span>
                        </v-tooltip>
                    </div>
                </v-col>
                <v-col cols="auto">
                    <div class="drop_area" cols="auto" :class="classesDragArea" @dragover.prevent="onArea" @drop.prevent="dropFile" @dragleave.prevent="offArea" @dragend.prevent="offArea">
                        <div style="margin-top: 60px;">
                            <p class="mb-0">PDFをアップロード</p>
                            <p class="mb-2" style="font-size:70%">ファイルをドラッグ＆ドロップ</p>
                            <p class="mb-2">or</p>
                            <label class="file_select v-label v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default">
                                ファイルを選択<input name="file[]" class="file_input" @change="changeFile" ref="file" type="file" accept="application/pdf" multiple>
                            </label>
                        </div>
                    </div>
                </v-col>
                <template v-if="template == true">
                    <v-col cols="auto">
                        <div class="drop_area" cols="auto">
                            <div style="margin-top: 120px;">
                                <template v-if="files.length == 0">
                                    <label class="file_select v-label v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default" style="font-size: 2.3rem !important;" @click="templateLink">
                                        テンプレートから選択
                                    </label>
                                </template>
                                <template v-else>
                                    <button class="v-label v-btn v-btn--is-elevated v-btn--has-bg v-size--default" style="font-size: 2.3rem !important; background-color: #f5f5f5; color: white !important;" disabled>
                                        テンプレートから選択
                                    </button>
                                </template>
                            </div>
                        </div>
                    </v-col>
                </template>
                <template v-if="multipleSend == true && navi.plan == true && files.length == 0">
                    <v-col cols="auto">
                        <div class="drop_area" cols="auto">
                            <div style="margin-top: 100px;">
                                <p class="mb-0">一括送信</p>
                                <label class="file_select v-label v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default" style="font-size: 2.3rem !important;" @click="multipleSendtemplateLink">
                                    テンプレートから選択
                                </label>
                            </div>
                        </div>
                    </v-col>
                </template>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        props: {
            navi: [],
            dbFileList: Array,
            pdfServerCheck: {
                type: Boolean(),
                default: true,
                required: false,
            },
            template: false,
            edit: false,
            multipleSend: false,
        },
        data () {
            return {
                files: [],
                // error: '',
                inArea: false,
                increment: 0,
                message: {
                    success: false,
                    text: '',
                },
            };
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
            classesDragArea () {
                return {
                    'drag_on': this.inArea
                };
            },
        },
        filters: {
            omittedText(text) {
                if(text === undefined || text === null){
                    return '';
                }
                // 10文字目以降は"…"
                return text != null && text.length > 10 ? text.slice(0, 10) + "…" : text;
            },
            omittedText30(text) {
                if(text === undefined || text === null){
                    return '';
                }
                // 30文字目以降は"…"
                return text != null && text.length > 30 ? text.slice(0, 30) + "…" : text;
            }
        },
        methods: {
            dropFile(e) {
                this.changeFile(e);
                this.offArea();
            },
            async changeFile(e) {
                const files = e.target.files || e.dataTransfer.files;
                if (files.length + this.dbFileList.length > 100) {
                    this.message.text = "1つの書類につきファイルは最大100ファイルまでです";
                    this.message.success = false;
                    this.$refs.file.value = null;
                    return false;
                }
                let sumFileSize = 0;
                for(let i = 0; i < files.length; i++){
                    // ファイルサイズ
                    if (files[i].size > (40 * 1024 * 1024)) {
                        this.message.text = "1ファイルのサイズは最大40MBまでです";
                        this.message.success = false;
                        this.$refs.file.value = null;
                        return false;
                    }
                    
                    sumFileSize = sumFileSize + files[i].size;
                }
                sumFileSize = sumFileSize + this.getDbFileSize() + this.getUpTempFileSize();
                // 50 * 1024 * 1024
                if (sumFileSize > (100 * 1024 * 1024)) {
                    this.message.text = "ファイルサイズは合計で最大100MBまでです";
                    this.message.success = false;
                    this.$refs.file.value = null;
                    return false;
                }
                
                let validFiles = await this.checkPdf(files);
                for(let i = 0; i < validFiles.length; i++){
                    if (validFiles[i]) {
                        var sn = this.getSn();
                        this.files.push([{
                            'sn': sn,
                            'file': files[i],
                            'file_name': files[i].name
                        }]);
                    }
                    // this.$set(this.files, "sn", sn);
                    // this.$set(this.files, "file", files[i]);
                }
                // インプットクリア
                this.$refs.file.value = null;
                // 親コンポーネントへ値渡し
                this.$emit("triggerEvent", this.files);
            },
            deleteDbFile (index) {
                // 親コンポーネントへ値渡し
                this.$emit("triggerEvent2", index);
            },
            deleteFile (index) {
                this.files.splice(index, 1);
                // this.$refs
            },
            deleteAllFiles () {
                // 全件削除
                this.files.splice(0);
            },
            getSn () {
                this.increment++;
                return this.increment;
            },
            templateLink () {
                window.location = '/documents/agreements/template';
            },
            multipleSendtemplateLink () {
                window.location = '/documents/multiple-send/template';
            },
            checkPdf: async function(files) {
                var self = this;
                let result = [];
                
                if (this.pdfServerCheck == false) {
                    for(let i = 0; i < files.length; i++){
                        result.push(true);
                    }
                    return result;
                }

                let formData = new FormData();
                for(let i = 0; i < files.length; i++){
                    formData.append('files[]', files[i]);
                }
                let config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                };
                await window.axios
                    .post('/documents/agreements/checkPdfFile', formData, config)
                    .then(function (response) {
                        if (!response.data.success) {
                            if (response.data.errors != null && response.data.errors.message != null) {
                                self.message.text = response.data.errors.message;
                            } else {
                                self.message.text = "不正なファイルが見つかりました";
                            }
                            self.message.success = false;
                        }
                        result = response.data.files;
                    })
                    .catch(function (response) {
                        result = [];
                        console.log(response);
                        self.message.text = "ファイルのチェック処理に失敗しました";
                        self.message.success = false;
                    }
                );
                return result;
            },
            getDbFileSize: function() {
                let sumSize = 0;
                for(let i = 0; i < this.dbFileList.length; i++){
                    sumSize = sumSize + this.dbFileList[i].pdfSize;
                }
                return sumSize;
            },
            getUpTempFileSize: function() {
                let sumSize = 0;
                for(let i = 0; i < this.files.length; i++){
                    sumSize = sumSize + this.files[i][0].file.size;
                }
                return sumSize;
            },
            onArea  () { this.inArea = true;  },
            offArea () { this.inArea = false; },
        }
    };
</script>

<style scoped>
    .file_input {
        display: none;
    }
    .file_select:hover {
        cursor: pointer;
    }
    .thumb_wrap {
        width:240px;
        max-width: 240px;
        /*height:328px;*/
        /*max-height:328px;*/
    }
    .thumb  {
        /*width: 196px;*/
        /*height: 260px;*/
        
        font-size: 1.4rem;
        margin-left: 20px;
    }
    .reset_file_ico {
        display: inline-flex;
        position: absolute;
        right: -5px;
        top: -5px;
    }
    .reset_file_ico:hover {
        cursor: pointer;
    }
    #error {
        color: #d70035;
    }
    .drop_area {
        width: 320px;
        height: 320px;
        padding: 15px;
        text-align: center;
        border: 1px dashed #c6c6c6;
        border-radius: 50%;
        background-color: #f9f9f9;
        
        text-align: center;
        margin: 0 auto;
    }
    .drag_on {
        border: 2px dashed #bcbcbc;
        background-color: #fafdff;
    }
    
    .file-name-text-field ::v-deep input {
        font-size: 1.5rem !important;
    }
    
    .file-name-text-field ::v-deep .v-input__slot {
        height: 36px !important;
        min-height: 30px !important;
    }
    
    ::v-deep .file-name-text-field {
        margin-left: 20px;
        width: 197px;
    }
</style>